import { EntitiesVisualizer } from '../entities-visualizer';
import { VisualizerStateStyle } from '../models/visualizer-state';

export const GoToVisualizerType = 'GoToVisualizer';

export class GoToVisualizer extends EntitiesVisualizer {
	static type = GoToVisualizerType;

	constructor(style: Partial<VisualizerStateStyle>) {
		super(GoToVisualizerType, style, {
			initial: {
				icon: {
					scale: 1,
					src: '/ansyn/assets/icons/tools/go-to-map-marker.svg'
				}
			}
		});
	}
}



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/open-layer-visualizers/tools/goto.visualizer.ts